/** Return a usable HTTPS URL, or null when an optional external link is absent or invalid. */
export function getHttpsUrl(value?: string | null): string | null {
  const trimmed = value?.trim();
  if (!trimmed || !/^https:\/\//i.test(trimmed)) return null;
  try {
    const url = new URL(trimmed);
    return url.protocol === 'https:' && url.hostname ? url.href : null;
  } catch {
    return null;
  }
}
